import React from 'react'
import { Modal, Button } from '@arnsbogroup/react-voicearchive'

/**
 * Every other edit is staged until Save, but resetting deletes the saved layout
 * on the spot and cannot be undone - so it asks first.
 */
const ResetLayoutModal = ({ show = false, resetting = false, onConfirm, onClose }) => (
  <Modal
    show={show}
    title="Reset dashboard to default?"
    onClose={onClose}
    onOutsideClick={onClose}
    onSubmit={onConfirm}
  >
    <p className="text-sm text-gray-700">
      Your saved layout will be deleted and replaced with the standard layout for your
      team. This cannot be undone.
    </p>

    <div className="mt-6 flex justify-end gap-2">
      <Button variant="outline" size="sm" onClick={onClose}>
        Keep my layout
      </Button>
      <Button
        variant="solid"
        state="negative"
        size="sm"
        disabled={resetting}
        onClick={onConfirm}
      >
        {resetting ? 'Resetting…' : 'Reset dashboard'}
      </Button>
    </div>
  </Modal>
)

export default ResetLayoutModal
